import { isEmpty } from 'lodash';
import { createSelector } from 'reselect';

export const getRelationshipManagerData = (state) =>
  state.userManager && state.userManager.manager
    ? state.userManager.manager
    : {};

export const getHasRelationshipManager = createSelector(
  getRelationshipManagerData,
  (relationshipManagerData) => {
    return (
      relationshipManagerData.person && !isEmpty(relationshipManagerData.person)
    );
  }
);

export const getRelationshipManagerName = createSelector(
  getRelationshipManagerData,
  (relationshipManagerData) => {
    return relationshipManagerData.person &&
      relationshipManagerData.person.displayName
      ? relationshipManagerData.person.displayName
      : '';
  }
);
